import React from 'react'
import {Aboutme} from './aboutme'
import {Preview as PreviewImages} from '../../../@shared/image_upload/preview'

export const Left = () => {
    
    return (
      <div>
        <Aboutme  />
      </div>
    )
  }